import Index from '../modules/tag';

export default Index;
